// modules/form.js
// Keep track of form and route data

import BookingsView from "@/views/Bookings.vue";
import FormDeparting from "@/components/forms/Departing.vue";
import FormReturning from "@/components/forms/Returning.vue";
import FormPassengers from "@/components/forms/Passengers.vue";
import FormAccount from "@/components/forms/Account.vue";
import FormContact from "@/components/forms/Contact.vue";
import FormPayment from "@/components/forms/Payment.vue";
import FormSummary from "@/components/forms/Summary.vue";
import Guest from "@/components/forms/sections/LoginGuest.vue";
import LoginUser from "@/components/forms/sections/LoginUser.vue";
import NewUser from "@/components/forms/sections/LoginNew.vue";
import PaymentForm from "@/components/forms/sections/PaymentForm.vue";
import PageComplete from "@/components/pages/Complete.vue";
import CargoPets from "@/content/cargo_pets.vue";

const defaultStatus = {
  error: false,
  complete: false,
  errorText: "Incomplete",
  errorDetails: ""
};

const departingFields = [
  {
    label: "Locations",
    status: defaultStatus,
    fields: [
      {
        name: "dep_loc",
        defaultValue: 5,
        validations: {}
      },
      {
        name: "dest_loc",
        defaultValue: null,
        validations: {}
      }
    ]
  },
  {
    label: "Dates",
    status: {
      error: false,
      complete: true,
      errorText: "Incomplete",
      errorDetails: ""
    },
    fields: ["dep_date", "ret_date"]
  },
  {
    label: "Passenger Count",
    status: {
      error: false,
      complete: true,
      errorText: "Incomplete",
      errorDetails: ""
    },
    fields: ["pax_a", "pax_c", "pax_i"]
  },
  {
    label: "Departing",
    status: {
      error: false,
      complete: false,
      errorText: "Incomplete",
      errorDetails: ""
    },
    fields: ["departFlight"]
  }
];

const dFlight = {
  name: "Departing",
  path: "/booking/departing/from/:from/to/:to/date/:date/adults/:pax_a/children/:pax_c/infants/:pax_i/return/:return",
  component: FormDeparting,
  active: true,
  props: true,
  meta: {
    icon: "lens",
    status: defaultStatus,
    fields: departingFields,
  },
  children: [
    {
      name: "Departing External",
      path: "/booking/departing",
      component: FormDeparting,
      fields: departingFields,
    },
    {
      name: "Departing Changes",
      path: "/booking/edit/:id",
      component: FormDeparting,
      fields: departingFields,
    },
  ],
};

const rFlight = {
  name: "Return",
  path: "/booking/return/from/:from/to/:to/date/:date/adults/:pax_a/children/:pax_c/infants/:pax_i",
  component: FormReturning,
  active: false,
  props: true,
  meta: {
    icon: "lens",
    status: defaultStatus,
    fields: [
      {
        label: "Returning Passengers",
        status: {
          error: false,
          complete: true,
          errorText: "Incomplete",
          errorDetails: "",
        },
        fields: ["pax_a_r", "pax_c_r", "pax_i_r"],
      },
      {
        label: "Return",
        status: {
          error: false,
          complete: false,
          errorText: "Incomplete",
          errorDetails: "",
        },
        fields: ["returnFlight"],
      },
    ],
  },
};

const passengers = {
  name: "Passengers",
  path: "/booking/passengers",
  component: FormPassengers,
  active: true,
  props: true,
  meta: {
    icon: "lens",
    status: defaultStatus,
  },
};

const account = {
  name: "Account",
  path: "/booking/account",
  component: FormAccount,
  active: true,
  props: true,
  meta: {
    icon: "lens",
    status: defaultStatus
  },
  children: [
    {
      name: "Login",
      path: "/booking/account",
      component: LoginUser,
    },
    {
      name: "Guest",
      path: "/booking/user/guest",
      component: Guest,
    },
    {
      name: "New",
      path: "/booking/user/new",
      component: NewUser,
    }
  ]
};

const contact = {
  name: "Contact",
  path: "/booking/contact",
  component: FormContact,
  active: true,
  props: true,
  meta: {
    icon: "lens",
    status: defaultStatus,
  },
};

const payment = {
  name: "Payment",
  path: "/booking/payment",
  component: FormPayment,
  active: true,
  props: true,
  meta: {
    icon: "lens",
    status: defaultStatus,
  },
  children: [
    {
      name: "Payment Form",
      path: "/booking/payment",
      component: PaymentForm,
    },
    {
      name: "Complete",
      path: "/booking/complete",
      component: PageComplete,
    },
  ],
};

const summary = {
  name: "Summary",
  path: "/booking/summary",
  component: FormSummary,
  active: true,
  props: true,
  meta: {
    icon: "lens",
    status: defaultStatus,
  },
};

const cargo = {
  name: "Cargo & Pets",
  path: "/booking/cargo_pets",
  component: { template: CargoPets },
};

const bookingFormFields = [
  dFlight,
  passengers,
  account,
  contact,
  summary,
  payment
];

const bookingFormReturnFields = [
  dFlight,
  rFlight,
  passengers,
  account,
  contact,
  summary,
  payment
];

const Routes = [
  {
    path: "/",
    component: BookingsView,
    children: bookingFormReturnFields,
  },
  {
    path: "/booking/info/cargo",
    component: CargoPets,
  },
  {
    path: "/*",
    redirect: "/",
  },
];

export { bookingFormFields, bookingFormReturnFields, rFlight };

export default Routes;
